import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69f8b756f6558f0014512dff/chatdesk/src/app/sign-up-login/components/AuthForm.tsx");
